import ActionType from 'actions/ActionType'

export default (state = false, action) => {
  switch (action.type) {
    case ActionType.Campaign.TOGGLE_DATE_RANGE:
      return action.payload === 'true'
    case ActionType.Campaign.RECEIVE_CAMPAIGN:
      if (action.payload) {
        if (action.payload.start_date || action.payload.end_date) {
          return true
        }
        return false
      }
      return false
    default:
      return state
  }
}
